import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "translatedName",
  standalone: false
})
export class TranslatedNamePipe implements PipeTransform {
  transform(nameObject: any, currentLang: string): string {
    if (nameObject) {
      return typeof nameObject === "object" ? nameObject[currentLang] : nameObject;
    }
    return "";
  }
}
